import React from 'react';
import { Link } from 'react-router-dom';

function Blog() {
    return (
        <section className="blog-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col col-lg-4">
                        <div className="section-title-s4">
                            <div className="icon">
                                <i className="fi flaticon-light-bulb"></i>
                            </div>
                            <span>Latest Blog</span>
                            <h2>Check Our Latest Tips &amp; News</h2>
                            <p>Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nuncIt showed a lady fitted</p>
                            <Link to="/blog" className="theme-btn">More Blog Post</Link>
                        </div>
                    </div>
                    <div className="col col-lg-8">
                        <div className="blog-grids clearfix">
                            <div className="grid">
                                <div className="entry-media">
                                    <img src="assets/images/blog/img-1.jpg" alt="" />
                                </div>
                                <div className="entry-details">
                                    <div className="cat">Adovcate, Law</div>
                                    <h3><Link to="/blog-single">Provide insight into how canna businesspeople can use</Link></h3>
                                    <Link to="/blog-single" className="read-more">Read More</Link>
                                </div>
                            </div>
                            <div className="grid">
                                <div className="entry-media">
                                    <img src="assets/images/blog/img-2.jpg" alt="" />
                                </div>
                                <div className="entry-details">
                                    <div className="cat">Adovcate, Law</div>
                                    <h3><Link to="/blog-single">Canna Law Blog is a forum for discussing the practical</Link></h3>
                                    <Link to="/blog-single" className="read-more">Read More</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Blog;